import styled from '@emotion/styled';

export const MainContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const LeftPlaceholder = styled.div`
  width: calc(100% - 290px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding-right: 24px;
  font-size: 18px;

  @media (max-width: 1200px) {
    width: 100%;
    padding: 16px;
  }
`;

export const RightWidgetContainer = styled.div`
  padding-top: 24px;
  width: 290px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1200px) {
    width: 100%;
    margin-top: 24px;
  }
`;

export const StyledActionButtonContainer = styled.div`
  margin-bottom: 24px;

  button {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const DetailViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;
